module.exports = __webpack_public_path__ + "img/responsive.54076993.jpg";